import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    marginTop: 20,
    marginBottom: 25,
    fontWeight: 'bold',
    fontSize: 20,
  },
  goBack: {
    marginBottom: '1rem',
    '&:hover': {
      backgroundColor: 'transparent',
      fontWeight: 'bold',
    },
  },
  tdCheckbox: {
    '& .MuiSvgIcon-root': {
      height: 30,
      width: 30,
    },
  },
  headerCheckBox: {
    '& .MuiSvgIcon-root': {
      height: 30,
      width: 30,
    },
  },
  isInsuredBlock: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '1.2rem',
    padding: '1rem',
    borderRadius: 6,
    backgroundColor: theme.palette.white.efesBackgroundLight,
    marginBottom: 30,
  },
  isInsuredText: {
    color: theme.palette.blue.efesDarkBlue,
  },
  agreementText: {
    fontSize: 12,
    textAlign: 'justify',
  },
  mobileSummaryCheckbox: {
    display: 'flex',
  },
  agreementLabelDisabled: {
    opacity: 0.5,
  },
  arrowIcon: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

export default useStyles;
